const ExamMarking = (r) => require(['@/v2/views/network/index'], r) // 网络阅卷列表
const StudentManage = (r) => require(['@/v2/views/exam/manage/student-manage'], r) // 学生管理页面
const TeacherManage = (r) => require(['@/v2/views/exam/manage/teacher-manage'], r) // 教师管理页面
const ExamMarkingTask = r => require(["@/v2/views/network/examTask"], r) //
const ExamIndex = r => require(['@/v2/views/exam/index'], r)
const CreateExam = r => require(['@/v2/views/exam/create'], r)

export default [
  {
    path: '/v2/exam/marking',
    name: 'exam-wuhen',
    meta: { auth: 'Region-Exam-Wuhen', keepAlive: true },
    component: ExamMarking
  },
  {
    path: '/region/exam/single/student-manage/:id',
    name: 'exam-student-manage',
    meta: { auth: 'Region-Exam-Wuhen' },
    component: StudentManage
  },
  {
    path: '/region/exam/single/teacher-manage/:id',
    name: 'exam-teacher-manage',
    meta: { auth: 'Region-Exam-Wuhen' },
    component: TeacherManage
  },
  {
    path: "/region/exam/marking/examTask",
    name: "exam-marking-task",
    meta: { auth: "Region-Exam-Wuhen" },
    component: ExamMarkingTask,
  },
  {
    path: '/region/exam/single',
    name: 'ExamIndex',
    meta: { auth: 'Region-Exam-Single', keepAlive: true },
    component: ExamIndex,
  },
  {
    path: '/region/exam/single/create',
    name: 'CreateExam',
    meta: { auth: 'Region-Exam-Single' },
    component: CreateExam,
  },
  {
    path: '/region/exam/single/edit/:id',
    name: 'EditExam',
    meta: { auth: 'Region-Exam-Single' },
    component: CreateExam,
  },

]


// WEBPACK FOOTER //
// ./src/v2/router/index.js